'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OPEN_CLASS = "a-modal-opened";
var TIME_DURATION = 300;

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.onCancel = function (e) {
      var onCancel = _this.props.onCancel;
      if (onCancel) {
        onCancel(e);
      }
    };

    _this.onMaskClick = function (e) {
      if (Date.now() - _this.openTime < TIME_DURATION) {
        return;
      }
      if (e.target === e.currentTarget) {
        _this.onCancel(e);
      }
    };

    _this.state = {
      toggleAnimation: props.visible,
      hideModal: !props.visible
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var props = this.props;
      var bodyClass = document.body && document.body.classList;
      if (props.visible) {
        // first show
        if (!prevProps.visible) {
          this.openTime = Date.now();
        }
        //use mouse scroll for the modal
        if (bodyClass && !bodyClass.contains(OPEN_CLASS)) {
          bodyClass.add(OPEN_CLASS);
        }
      } else {
        if (bodyClass) {
          setTimeout(function () {
            bodyClass.remove(OPEN_CLASS);
          }, TIME_DURATION);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var bodyClass = document.body && document.body.classList;
      if (bodyClass) {
        bodyClass.remove(OPEN_CLASS);
      }
    }
  }, {
    key: 'cleanTimer',
    value: function cleanTimer() {
      if (this.setStateTimer) {
        clearTimeout(this.setStateTimer);
        this.setStateTimer = null;
      }
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({ toggleAnimation: nextProps.visible });
      var self = this;
      /** Make sure that disappear animation **/
      this.cleanTimer();
      this.setStateTimer = setTimeout(function () {
        self && self.setState({ hideModal: !nextProps.visible });
      }, nextProps.visible ? 0 : TIME_DURATION);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          className = _props.className,
          children = _props.children,
          visible = _props.visible,
          onCancel = _props.onCancel,
          backdropClosable = _props.backdropClosable,
          zIndex = _props.zIndex,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'children', 'visible', 'onCancel', 'backdropClosable', 'zIndex']);

      var classes = (0, _classnames2.default)('modal-dialog', className);

      var modalWrapperClass = (0, _classnames2.default)('a-modal appkit-animation animated fadeIn', {
        'modal-opened': !this.state.hideModal,
        'modal-closed': this.state.hideModal
      });

      var wrapperStyle = zIndex ? { zIndex: zIndex } : null;

      var content = _react2.default.Children.map(children, function (child) {
        var element = void 0;
        if (child.type && child.type.displayName === 'ModalHeader') {
          element = _react2.default.cloneElement(child, {
            onClick: function onClick(item) {
              return _this2.onCancel(item);
            }
          });
        } else {
          element = child;
        }

        return element;
      });

      var theme = (0, _index.getCurrentTheme)();
      var level = (0, _index.getCurrentLevel)();

      //turn modal into a themeContainer
      var contentCn = (0, _classnames2.default)("modal-content", {
        "a-theme-container": theme
      });

      return _react2.default.createElement(
        'div',
        { className: modalWrapperClass, style: wrapperStyle },
        _react2.default.createElement(
          _index.Animations,
          {
            effect: this.state.toggleAnimation ? 'fadeInDown' : 'fadeOutUp',
            active: true
          },
          _react2.default.createElement(
            'div',
            { className: classes },
            _react2.default.createElement(
              'div',
              Object.assign({ style: style, className: contentCn, theme: theme, level: level }, otherProps),
              content
            )
          )
        ),
        _react2.default.createElement(
          _index.Animations,
          {
            effect: this.state.toggleAnimation ? 'fadeIn' : 'fadeOut',
            active: true
          },
          _react2.default.createElement('div', {
            className: 'modal-backdrop',
            onKeyUp: backdropClosable ? this.onMaskClick : undefined,
            onClick: backdropClosable ? this.onMaskClick : undefined
          })
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.defaultProps = {
  backdropClosable: true
};


Modal.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  backdropClosable: _propTypes2.default.bool,
  onCancel: _propTypes2.default.func
};

Modal.displayName = 'Modal';
exports.default = Modal;